<div class="channel-table-row-background channel-table-row text">
    <div class="alarm-bg-wrapper">
        <div data-cy="dashboard-channel-group-tab-ch-number" class="col-ch-no opaque">
            {{ channel.opsData.tag }}
        </div>
        <div data-cy="dashboard-channel-group-tab-ch-name" class="col-ch-name opaque">
            {{ channel.opsData.name }}
        </div>
        <div data-cy="dashboard-channel-group-tab-details-button" class="col-ch-btn">
            <button class="primary">
                {{ "alarm.button.details" | translate | uppercase }}
            </button>
        </div>
    </div>
</div>
